import React from 'react';
import './version-viewer.css';

/**
 * A little top left absolute component that shows the application version. The information above needs to be specified in getClientState function as the following JSON:
 * ```json
 * "appVersion":{
 *      "enabled": true,
 *      "version": "0.1.1"
 * }
 * ```
 */
const VersionViewer = (props) => {
    if (!props.appVersion) return null;
    return (
        <div className='hbbtv-version-container'>
            <span className='hbbtv-version'>{props.appVersion.version}</span>
        </div>
    );
}

export default VersionViewer;

